<div *ngIf="!data.isV2">
  <div class="content-container">
    <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon>
    <span class="content-span full-width">{{data.message}}</span>
  </div>
  <ng-container *ngIf="!data.isOk">
    <button mat-flat-button id="no-button" data-testid="dialog-confirm-no-button" [mat-dialog-close]="false">NO</button>
    <button mat-flat-button id="yes-button" data-testid="dialog-confirm-yes-button" [mat-dialog-close]="true">YES</button>
  </ng-container>
  <ng-container *ngIf="data.isOk">
    <button mat-flat-button id="ok-button" data-testid="dialog-confirm-ok-button" [mat-dialog-close]="true">OK</button>
  </ng-container>
</div>
<div class="v2-container" *ngIf="data.isV2">
  <mat-toolbar *ngIf="data.title" color="primary">
    <span>{{data.title}}</span>
  </mat-toolbar>
  <div class="content-container">
    <span class="content-span full-width" [innerHTML]="safeHtml"></span>
  </div>
  <div class="actions-container" *ngIf="!data.isOk">
    <button mat-raised-button data-testid="dialog-confirm-no-button" [mat-dialog-close]="false">NO</button>
    <button color="primary" mat-raised-button data-testid="dialog-confirm-yes-button" [mat-dialog-close]="true">YES</button>
  </div>
  <div class="actions-container" *ngIf="data.isOk">
    <button color="primary" mat-raised-button data-testid="dialog-confirm-ok-button" [mat-dialog-close]="true">OK</button>
  </div>
</div>